import React from 'react';
import { round } from 'lodash';
import classNames from 'classnames';

import styles from './WindIndicator.module.scss';

interface WindIndicatorProps {
  direction?: number;
  speed?: number;
  units?: string;
}

const WindIndicator: React.FC<WindIndicatorProps> = ({ direction = 0, speed = 0, units = '' }) => {
  const adjustedSpeed = round(speed);
  return (
    <svg
      className={classNames(styles.windIndicator, 'quiver-wind-indicator')}
      data-testid="wind-indicator"
    >
      <g>
        <g transform={`rotate(${direction} 17.5 17.5)`} data-testid="wind-indicator-rotate">
          <circle cx="17.5" cy="17.5" r="16" />
          <polygon points="14.5 2.75, 17.5 2.5, 20.5 2.75, 17.5 6" />
        </g>
        <g>
          <text x="50%" y="51%">
            {adjustedSpeed}
          </text>
          <text x="50%" y="70%">
            {units}
          </text>
        </g>
      </g>
    </svg>
  );
};

export default WindIndicator;
